import { hasPermission } from '@sopranodesign/pulse-auth';

import {
  NlpDrivers,
  NlpDriverSettings,
  SemanticSearchDrivers
} from './Pages/index';

const routes = [
  {
    path: '/nlp',
    component: NlpDrivers,
    name: 'NLP Providers',
    canAccess: hasPermission('view nlp providers')
  },
  {
    path: '/nlp/settings',
    component: NlpDriverSettings,
    name: 'NLP Settings',
    canAccess: hasPermission('edit nlp providers')
  },
  {
    path: '/semantic-search',
    component: SemanticSearchDrivers,
    name: 'Semantic Search Providers',
    canAccess: hasPermission('view nlp providers')
  }
];

export default routes;
